"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icon_success",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.3",
    cx: "12",
    cy: "12",
    r: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.33301 12.2917L10.2497 15.2083L16.3747 9.08333",
    stroke: "#36B37E",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

Svg.propTypes = {
  /** Margins */
  margin: _propTypes.default.string
};
Svg.defaultProps = {
  margin: '0'
};
var _default = Svg;
exports.default = _default;